import { useQuery, useQueryClient } from '@tanstack/react-query'

import { getCities } from '@/services/project-adress'

export const GET_CITIES_QUERY = ['cities']

export function useGetAddressCities(uf: string) {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: [...GET_CITIES_QUERY, { uf }],
    queryFn: () => getCities(uf),
    staleTime: 1000 * 60 * 60 * 24, // 1 dia
  })

  const fetchCities = (uf: string) => {
    return queryClient.refetchQueries([GET_CITIES_QUERY, { uf }])
  }

  return { ...query, fetchCities }
}
